import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import getConfigDetails  from '../../services/config'
import { getFormattedAmountNumber } from '../../utils/helper'
// import { postCardPaymentDetails } from '../../redux/actions/transientAction'
// import { errorMessage } from '../../constants/errorMessage'
// import { useNavigate } from 'react-router-dom'
const ApplePayHL = (props) => {
    const {
        faciltyData,
        getValues,
        setIsSubmittingForm,
        // seletedRateBand,
        // totalHoursLength,
        // events,
        // selectedEv,
        // qrcodeId,
        // dispatch,
        // setIsConfimationModalOpen,
        // setIsRateMisMatch,
        // setMismatchRateError,
        // setIsTokenApiStart,
        // notify,
        // partner,
        // isDisplayRateBand,
        // loginData,
        onSubmit,
        applePaySessionRef,
        payableAmount
    } = props
    const [applePayBtm, setApplePayBtm] = useState(false)
    
    // const navigate = useNavigate()
    useEffect(() => {
        if (window?.ApplePaySession) {
            if(window?.ApplePaySession.canMakePayments()) {
                setApplePayBtm(true)
            }
        }
    }, [])
    const initializeApplePay = () => {
        
        // Check if the user's browser supports Apple Pay
        if (window?.ApplePaySession && window?.ApplePaySession?.canMakePayments()) {
            const paymentRequest = {
                countryCode: 'US',
                currencyCode: 'USD',
                supportedNetworks: ['visa', 'masterCard', 'amex'],
                merchantCapabilities: ['supports3DS'],
                total: { label: 'Your Store', amount: getFormattedAmountNumber(payableAmount) }
            }
            const session = new window.ApplePaySession(3, paymentRequest)
            applePaySessionRef.current = session
            // Validate merchant with your backend PHP script
            session.onvalidatemerchant = (event) => {
                // console.log(event)
                // console.log(event.validationURL, 'event.validationURL')
                // var payload = {'merchantIdentifier':'777704037403','displayName':'Parkengage','initiative':'web','initiativeContext':'https://staging-transient.parkengage.com', 'validationURL': event.validationURL}
                // var payload = {'merchantIdentifier':'merchant.com.ApplePayHLWebSampleFinal','displayName':'Parkengage','initiative':'web','initiativeContext':'https://staging-transient.parkengage.com', 'validationURL': event.validationURL}
            
                // var data = new FormData()
                // data.append( 'json', JSON.stringify( payload ) )
                fetch(`${getConfigDetails.baseURL}apple-pay-session`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    //   body: JSON.stringify({ validationURL: event.validationURL })
                    body: JSON.stringify({ 'merchantIdentifier': faciltyData?.facility_payment_details?.heartland_applepay_identifier,
                        'displayName': faciltyData?.facility_payment_details?.heartland_merchant_name,
                        'initiative': 'web',
                        'initiativeContext': window.location.hostname,
                        'validationURL': event.validationURL,
                        'facility_id': faciltyData?.id
                    })
                })
                .then(response => response.json())
                .then(data => {
                if (data.error) {
                    console.error('Merchant validation failed', data.error)
                } else {
                    const validMerchantData = JSON.parse(data?.data ? data?.data : '{}')
                    // let payload = {
                    //     'status': '200',
                    //     'statusMessage': validMerchantData,
                    //     'statusCode': 200
                    // }
                    session.completeMerchantValidation(validMerchantData)
                }
                })
                .catch((error) => {
                    session.abort()
                    console.error('Validation error:', error)
                })
            }
            // Handle payment authorization
            session.onpaymentauthorized = (event) => {
                setIsSubmittingForm(true)
                const paymentToken = event?.payment?.token
                const formData = getValues()
                const payload = {
                    ...formData,
                    walletPay: JSON.stringify(paymentToken?.paymentData),
                    amount: getFormattedAmountNumber(payableAmount),
                    // invoice_number: '1234',
                    paymentMethods: 'APL'
                }
                onSubmit(payload, 0)
                // const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                // let finalPayload = {}
                // finalPayload = {
                //     facility_id: faciltyData?.facility?.id,
                //     license_plate: upperData?.license_plate,
                //     color: upperData?.color,
                //     make: upperData?.make == 'Others' ? upperData?.maketext : upperData?.make,
                //     model: upperData?.model == 'Others' ? upperData?.modeltext : upperData?.model,
                //     phone: loginData?.user?.phone_number ? loginData?.user?.phone_number : upperData?.phone,
                //     // email: upperData?.email,
                //     length: seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength,
                //     discount_amount: facilityLocData?.discount_amount,
                //     promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                //     total: faciltyData?.payable_amount,
                //     check_warning: 0,
                //     transaction_id: upperData?.transaction_id ? upperData?.transaction_id : '',
                //     // paymentMethod: upperData?.paymentMethod ? upperData?.paymentMethod : '',
                //     paymentMethods: 'APL',
                //     walletPay: JSON.stringify(paymentToken?.paymentData)
                // }
                // if(loginData?.user) {
                //     finalPayload.email = loginData?.user?.email ? loginData?.user?.email : ''
                //     finalPayload.vehicle_id = upperData?.vehicle_id
                //     delete finalPayload.color
                //     delete finalPayload.make
                //     delete finalPayload.model
                // }
                // // state ID was sending if there is no option to select
                // if (upperData?.make || upperData?.model) {
                //     finalPayload.state_id = upperData?.state
                // }
                // if (faciltyData?.facility?.is_price_band == 1) {
                //     finalPayload.rate_band_id = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.id : isDisplayRateBand ? '' : undefined
                // }
                // // reverting for price zero
                // if (faciltyData?.permit_request_id && faciltyData?.permit_request_id != '') {
                //     finalPayload.permit_request_id = faciltyData?.permit_request_id
                // }
                // if (events.length > 0) {
                //     finalPayload.event_id = selectedEv
                //     delete finalPayload.length
                //     if (qrcodeId) {
                //         finalPayload.qrcode_id = qrcodeId
                //     }
                // }
                // if(upperData?.paymentMethod && upperData?.paymentMethod  != ''){
                //     delete finalPayload.nonce
                // }
                // dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                //     console.log(faciltyData, 'faciltyData')
                //     if (res?.status === 201 && res?.data) {
                //         const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                //         localStorage.removeItem('paymentRecipt')
                //         localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                //         navigate(`/${partner}${URL?.CONFIRMATION}`)
                //         session.completePayment(window.ApplePaySession.STATUS_SUCCESS)
                //     } else {
                //         if (res?.errors?.message && res?.errors?.message == 'You already have one active parking session. Please confirm if you want to end this first before proceeding further.') {
                //             setIsConfimationModalOpen(true)
                //         } else if (res?.errors?.detail?.isratemismatch) {
                //             setIsRateMisMatch(true)
                //             setMismatchRateError(res?.errors?.message)
                //         } else {
                //             setIsSubmittingForm(false)
                //             notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                //         }
                //         setIsTokenApiStart(false)
                //         session.completePayment(window.ApplePaySession.STATUS_FAILURE)
                //     }
                // }).catch((err) => {
                //     console.log(faciltyData, 'faciltyData err')
                //     setIsSubmittingForm(false)
                //     setIsTokenApiStart(false)
                //     if (err?.errors?.detail?.isratemismatch) {
                //         setIsRateMisMatch(true)
                //         setMismatchRateError(err?.errors?.message)
                //     } else {
                //         notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                //     }
                //     session.completePayment(window.ApplePaySession.STATUS_FAILURE)
                // })
            }
            // Begin the session
            session.begin()
        } else {
            console.log('Apple Pay is not supported on this device.')
        }
    }
    return (
        <div className='px-2 payButton mb-3 text-center'>
            { applePayBtm ? <button className="apple-pay-button" onClick={initializeApplePay}>&nbsp;</button> : '' }
        </div>
    )
}
ApplePayHL.propTypes = {
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    dispatch: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    setIsConfimationModalOpen: PropTypes.func,
    setIsRateMisMatch: PropTypes.func,
    setMismatchRateError: PropTypes.func,
    setIsTokenApiStart: PropTypes.func,
    notify: PropTypes.func,
    onSubmit: PropTypes.func,
    seletedRateBand: PropTypes.string,
    totalHoursLength: PropTypes.string,
    events: PropTypes.array,
    selectedEv: PropTypes.string,
    qrcodeId: PropTypes.string,
    partner: PropTypes.string,
    isDisplayRateBand: PropTypes.bool,
    loginData: PropTypes.object,
    applePaySessionRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    payableAmount: PropTypes.number
}
 
ApplePayHL.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    dispatch: noop,
    setIsSubmittingForm: noop,
    setIsConfimationModalOpen: noop,
    setIsRateMisMatch: noop,
    setMismatchRateError: noop,
    setIsTokenApiStart: noop,
    notify: noop,
    onSubmit: noop,
    seletedRateBand: '',
    totalHoursLength: '',
    events: EMPTY_ARRAY,
    selectedEv: '',
    qrcodeId: '',
    partner: '',
    isDisplayRateBand: false,
    loginData: EMPTY_OBJECT,
    applePaySessionRef: null,
    payableAmount: 0
}
export default ApplePayHL